// extracted by mini-css-extract-plugin
export default {"pageGrid":"styles_pageGrid__1sYl4"};